import { ref } from 'vue';
import type { EcxToastOptions } from '@edgeconnex/design-system';

// Sites pruned from a grid filter after leaving the caller's scope. useGridPreferences reports
// here rather than toasting: AppLayout owns the toast host, so one reassignment raises one toast.
export const droppedSites = ref<string[]>([]);

// Once per session: the prune re-runs on every grid mount, across 11 grids.
const announced = new Set<string>();

export function reportDroppedSites(codes: string[]): void {
  const fresh = codes.filter((code) => !announced.has(code));
  if (!fresh.length) {
    return;
  }
  fresh.forEach((code) => announced.add(code));
  droppedSites.value = [...new Set([...droppedSites.value, ...fresh])];
}

export function buildDroppedSitesNotice(codes: string[]): EcxToastOptions | null {
  if (!codes.length) {
    return null;
  }
  return {
    severity: 'warn',
    summary: 'Site filter updated',
    detail:
      codes.length === 1
        ? `Site "${codes[0]}" is no longer available and was removed from your filter.`
        : `${codes.length} sites are no longer available and were removed from your filter: ${codes.join(', ')}.`,
    life: 6000,
  };
}

// Drains the pending codes and returns the toast to raise, if any.
export function takeDroppedSitesNotice(): EcxToastOptions | null {
  const notice = buildDroppedSitesNotice(droppedSites.value);
  droppedSites.value = [];
  return notice;
}

// Test seam: the announced-set is module state that leaks between specs.
export function resetDroppedSites(): void {
  announced.clear();
  droppedSites.value = [];
}
